var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('youtube',{ref:"youtube",attrs:{"width":'100%',"height":680,"video-id":_vm.idVideo,"player-vars":_vm.playerVars},on:{"ended":_vm.youtubeFinish,"error":_vm.errorYoutube,"playing":_vm.playing}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }